import { PERMISSIONS } from "@/constants";

export default [
  {
    name: "groups",
    meta: {
      title: "Manage Groups",
      permission_scopes: [PERMISSIONS.IS_SUPERUSER],
    },
    path: "/manage/groups",
    component: () => import("@/views/pages/groups"),
  },
];
